import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const WeldTagStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
  pl: { sm: '500' },
  pr: { sm: '550' },
  py: { sm: '600' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey['300']};
  `}
`;
